<template>
  <span class="typing-dots">
    <span class="dot"></span>
    <span class="dot"></span>
    <span class="dot"></span>
  </span>
</template>

<script setup>
defineOptions({ name: "TypingDots" });
</script>

<style scoped>
/* AI 正在输出：三个点依次弹跳 */
.typing-dots {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 14px;
}
.typing-dots .dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #1768ff;
  animation: typingBounce 1.2s ease-in-out infinite;
}
.typing-dots .dot:nth-child(2) {
  animation-delay: 0.18s;
}
.typing-dots .dot:nth-child(3) {
  animation-delay: 0.36s;
}
@keyframes typingBounce {
  0%,
  60%,
  100% {
    transform: translateY(0);
    opacity: 0.45;
  }
  30% {
    transform: translateY(-4px);
    opacity: 1;
  }
}
</style>
